/**
 * Global axios setup.
 *
 * Registers a single request interceptor that auto-attaches
 *   Authorization: Bearer <token>
 * on EVERY axios call, reading the JWT from localStorage.
 *
 * Why this exists:
 *   Several upload screens (StockReport, ServiceUpload, ReconciliationTab, …)
 *   build their own axios.post(... , { headers: { 'Content-Type': 'multipart/form-data' } })
 *   and forget to add the Authorization header. The backend's iter-107
 *   `require_target_company_id` upload guard then rejects with
 *   "No target company resolved for this upload."
 *
 *   Patching each call site is whack-a-mole. This interceptor permanently
 *   fixes the entire class of bug — past, present, and future.
 *
 * Idempotency:
 *   If a call already supplies an Authorization header, this interceptor
 *   does NOT overwrite it. Explicit per-call headers (e.g. in LeadsList.js)
 *   still win.
 */
import axios from 'axios';

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token') || localStorage.getItem('token');
  if (token) {
    config.headers = config.headers || {};
    // Only set if the caller hasn't already supplied one
    if (!config.headers.Authorization && !config.headers.authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});
